import { render, staticRenderFns } from "./PercentageChangesCalculator.vue?vue&type=template&id=1f7feec7&scoped=true&"
import script from "./PercentageChangesCalculator.vue?vue&type=script&lang=js&"
export * from "./PercentageChangesCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7feec7",
  null
  
)

export default component.exports